'use client'

import * as StyledToast from './Toast.styles'

import dynamic from 'next/dynamic'

const ToastContainerComponent = (): JSX.Element => {
	return (
		<StyledToast.ToastContainer
			position="bottom-right"
			autoClose={3000}
			closeOnClick={false}
			closeButton={false}
			hideProgressBar
			transition={StyledToast.SlideAnimation}
			pauseOnHover={false}
			pauseOnFocusLoss={false}
			icon={false}
			draggable={true}
			stacked
		/>
	)
}

export const ClientToastContainer = dynamic(
	() => Promise.resolve(ToastContainerComponent),
	{
		ssr: false,
	}
)
